"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconAuditorFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0,18 L0,0 L1.34579439,1.36817102 L2.64886515,0 L3.99465955,1.34679335 L5.31909212,0 L6.66488652,1.34679335 L7.98931909,0 L9.33511348,1.34679335 L10.6595461,0 L12.0053405,1.34679335 L13.3511348,0 L14.6755674,1.34679335 L16,0 L16,18 L14.6755674,16.6745843 L13.3511348,18 L12.0053405,16.6745843 L10.6595461,18 L9.33511348,16.6745843 L7.98931909,18 L6.66488652,16.6745843 L5.31909212,18 L3.99465955,16.6745843 L2.62750334,18 L1.30307076,16.6745843 L0,18 Z M4,12.976247 L12,12.976247 L12,11.5653207 L4,11.5653207 L4,12.976247 Z M4,9.68408551 L12,9.68408551 L12,8.27315914 L4,8.27315914 L4,9.68408551 Z M4,6.37054632 L12,6.37054632 L12,4.95961995 L4,4.95961995 L4,6.37054632 Z M1.68758344,2.71496437 L1.68758344,15.2422803 L1.68758344,2.71496437 Z",
        id: "path-1-adf8493"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-660.000000, -1349.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(660.000000, 1349.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(4.000000, 3.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
              id: "mask-2-gd3231",
              fill: "white",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                xlinkHref: "#path-1-adf8493"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
              fill: "#000000",
              fillRule: "nonzero",
              xlinkHref: "#path-1-adf8493"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              mask: "url(#mask-2-gd3231)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(-4.000000, -3.000000)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  x: "0",
                  y: "0",
                  width: "24",
                  height: "24"
                })
              })
            })]
          })
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIcon.default)('IconAuditorFilled')(IconAuditorFilled);